module.exports = __webpack_public_path__ + "static/media/success.74cecaf1.mp3";